import { Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/core/styles';

export const useStyles = (theme: Theme) =>
  createStyles({
    listItemText: {
      transition: 'opacity 0.2s ease-out',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
    link: {
      textDecoration: 'auto',
    },
    labelButton: {
      borderRight: '1px important!',
      marginLeft: 10,
      borderRadius: '4px 0px 0px 4px',
    },
    selectButton: {
      borderLeft: '1px important!',
      borderRadius: '0px 4px 4px 0px',
      minWidth: 0,
      padding: '4px 2px',
    },
  });
